import React, { Component } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { connect } from 'react-redux';
import { history } from '../../../_helpers/history';
import { Prompt } from 'react-router';

import { initState } from '../../../_actions/questionnaire.actions';
import { reset } from '../../../_actions/document-builder.actions';

import ProgressBar from './ProgressBar/';
import QuestionBuilder from './QuestionBuilder/';
import NoteBuilder from './NoteBuilder/';
import DocumentBuilder from './DocumentBuilder/';

class QuestionnaireBuilder extends Component {
  constructor(props) {
    super(props)

    this.props.dispatch(initState());
    this.props.dispatch(reset());

    this.state = {
      currentStep: 'QUESTION_BUILDER',
    }

    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }


  componentWillUnmount() {
    this.props.dispatch(initState());
    this.props.dispatch(reset());
  }

  handleNext() {
    let next;

    if (this.state.currentStep === 'HPI_BUILDER') {
      next = { currentStep: 'DOCUMENT_BUILDER' };
    } else if (this.state.currentStep === 'QUESTION_BUILDER' && this.props.enableHPI) {
      next = { currentStep: 'HPI_BUILDER' };
    } else if (this.state.currentStep === 'QUESTION_BUILDER' && !this.props.enableHPI) {
      next = { currentStep: 'DOCUMENT_BUILDER' };
    }

    this.setState(next);
  }

  handleBack() {
    let previous;

    if (this.state.currentStep === 'DOCUMENT_BUILDER' && this.props.enableHPI) {
      previous = { currentStep: 'HPI_BUILDER' }
    } else if (this.state.currentStep === 'DOCUMENT_BUILDER' && !this.props.enableHPI) {
      previous = { currentStep: 'QUESTION_BUILDER' }
    } else if (this.state.currentStep === 'HPI_BUILDER') {
      previous = { currentStep: 'QUESTION_BUILDER' }
    } else {
      history.push('/questionnaires');
    }

    this.setState(previous);
  }

  handleClick(stepClicked) {
    let current = { currentStep: stepClicked }
    this.setState(current);
  }


  render() {
    const { saveSuccess } = this.props;

    return (
      <div className="row">
        <Prompt when={!saveSuccess} message="Are you sure you want to exit Questionnaire Builder without saving?" />
        <div className="col-lg-12">
          <ProgressBar
            next={this.handleNext}
            back={this.handleBack}
            click={this.handleClick}
            step={this.state.currentStep} />
        </div>

        <div className="col-lg-12">
          <DndProvider backend={HTML5Backend}>
            <QuestionBuilder currentStep={this.state.currentStep} />

            <NoteBuilder currentStep={this.state.currentStep} />

            <DocumentBuilder currentStep={this.state.currentStep} />
          </DndProvider>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const HPIquestions = state.questionnaire.current.item.filter((item) => {
    const isNote = item.extension.find((extension) => {
      return extension.url === 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-item-note' &&
        extension.valueBoolean;
    })

    return isNote;
  });

  return {
    enableHPI: HPIquestions.length > 0,
    saveSuccess: state.questionnaire.saveSuccess
  }
}

export default connect(mapStateToProps)(QuestionnaireBuilder);